import { call, put, takeLatest } from "redux-saga/effects";
import { forgotPasswordApi, loginApi } from "../Effects/AuthEffect";

function* handleLogin(action) {
  try {
    const user = yield call(loginApi, action.payload);

    if (
      !user ||
      !user.accessToken ||
      !user.refreshToken ||
      !user.user ||
      !user.user.email
    ) {
      console.log("LOGIN_FAILURE_USER");
      throw user;
    }
    const permissions = JSON.parse(user.user.access);

    yield put({
      type: "LOGIN_SUCCESS",
      payload: {
        accessToken: user.accessToken,
        refreshToken: user.refreshToken,

        user: {
          id: user.user.id,
          role: user.user.user_type_role_name,
          email: user.user.email,
          first_name: user.user.first_name,
          last_name: user.user.last_name,
          contact: user.user.phone,
          id: user.user.user_id,
          customer_id: user.user.customer_id,
          vendor_id: user.user.vendor_id,
          staff_id: user.user.staff_id,
          user_type: user.user.user_type,
          permissions
        }
      }
    });
  } catch (error) {
    console.log("LOGIN_FAILURE");
    yield put({ type: "LOGIN_FAILURE", payload: error.message });
  }
}

function* handleForgotPassword(action) {
  try {
    const response = yield call(forgotPasswordApi, action.payload.email);
    yield put({
      type: "FORGOT_PASSWORD_SUCCESS",
      payload: response.message || "Reset link sent successfully"
    });
  } catch (error) {
    yield put({
      type: "FORGOT_PASSWORD_FAILURE",
      payload: error.message || "Failed to send reset link"
    });
  }
}

function* handleLogout() {
  try {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    yield put({ type: "LOGOUT_SUCCESS" });
  } catch (error) {
    yield put({ type: "LOGOUT_FAILURE", payload: error.message });
  }
}
export function* watchLogout() {
  yield takeLatest("LOGOUT_REQUEST", handleLogout);
}

export function* watchForgotPassword() {
  yield takeLatest("FORGOT_PASSWORD_REQUEST", handleForgotPassword);
}
export function* watchLogin() {
  yield takeLatest("LOGIN_REQUEST", handleLogin);
}
